import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Icon as IconComponent } from '../Icon';
import { Loader } from '../Loader';
import { theme } from '../theme';
import { focusOutline } from '../utils/focusOutline';
export const Chip = forwardRef(({ children, handleClick, primary = false, secondary = false, disabled = false, loading = false, icon, ...props }, ref) => (React.createElement(Container, { forwardedAs: "button", "$primary": primary, "$secondary": secondary, disabled: disabled || loading, "$loading": loading, onClick: handleClick, "$icon": icon, ...props, ref: ref, "aria-label": "chip-button" }, loading ? (React.createElement(Loader, { color: primary ? 'liquorice' : 'cream', height: "16" })) : (React.createElement(React.Fragment, null,
    icon && (React.createElement(IconComponent, { render: icon, size: 16, color: primary ? 'liquorice' : 'cream' })),
    React.createElement(ChildrenContainer, null, children))))));
Chip.displayName = 'Chip';
const Container = styled(Box)(({ $primary, $secondary, $icon, $loading, disabled }) => css `
    ${focusOutline()}

    align-items: center;
    background-color: ${theme.colors.oatmeal};
    border-radius: 100px;
    border: 2px solid ${theme.colors.oatmeal};
    color: ${theme.colors.liquorice};
    display: flex;
    font-size: 16px;
    justify-content: ${$icon ? 'space-evenly' : 'center'};
    line-height: 100%;
    padding: 8px 16px 8px ${$icon ? '8px' : '16px'};
    min-width: 98px;
    min-height: 40px;
    cursor: ${disabled || $loading ? 'not-allowed' : 'pointer'};
    opacity: ${disabled ? '0.5' : '1'};

    ${$primary &&
    css `
      &:hover {
        border: ${!(disabled || $loading) &&
        `2px solid ${theme.colors.mascarpone}`};
        background-color: ${!(disabled || $loading) && theme.colors.mascarpone};
      }
    `}
    ${$secondary &&
    css `
      color: ${theme.colors.cream};
      background-color: ${theme.colors.liquorice};
      border: 2px solid ${theme.colors.liquorice};
      &:hover {
        border: ${!(disabled || $loading) &&
        `2px solid ${theme.colors.sesame}`};
        background-color: ${!(disabled || $loading) && theme.colors.sesame};
      }
    `};
  `);
const ChildrenContainer = styled.div `
  flex-grow: 1;
`;
//# sourceMappingURL=Chip.js.map